import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import api from '../../../services/API';
import { toast } from 'react-toastify';
import RegulamentoPainel from './Regulamento';
import './styles.css';

function ConfiguracoesSistema() {
  const [configuracao, setConfiguracao] = useState({
    bloquearResgate: false,
    bloquearPontuacao: false,
    bloquearSite: false,
  });
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    carregarConfiguracao();
  }, []);

  const carregarConfiguracao = async () => {
    try {
      const response = await api.get('/api/configuracoes');
      if (response.data) {
        setConfiguracao(response.data);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        // Não existe configuração ainda, usar valores padrão
        setConfiguracao({
          bloquearResgate: false,
          bloquearPontuacao: false,
          bloquearSite: false,
        });
      } else {
        toast.error('Erro ao carregar configurações', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setEnviando(true);

    try {
      if (configuracao.id) {
        // Atualizar configuração existente
        await api.put(`/api/configuracoes/${configuracao.id}`, configuracao);
        toast.success('Configurações atualizadas com sucesso!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else {
        // Criar nova configuração
        const response = await api.post('/api/configuracoes', configuracao);
        setConfiguracao(response.data);
        toast.success('Configurações criadas com sucesso!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.erro || 'Erro ao salvar configurações';
      toast.error(errorMessage, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="configuracoes-sistema-layout">
      <div className="configuracoes-sistema-card">
          <h5 className="configuracoes-sistema-titulo">
            Configurações do Sistema
          </h5>
          
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '25px' }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center', 
                cursor: 'pointer',
                padding: '15px',
                borderRadius: '6px',
                border: '1px solid #e0e0e0',
                backgroundColor: configuracao.bloquearResgate ? '#f8f9fa' : '#fff',
                transition: 'all 0.2s ease'
              }}>
                <input
                  type="checkbox"
                  checked={configuracao.bloquearResgate}
                  onChange={(e) => {
                    e.persist();
                    setConfiguracao(prev => ({
                      ...prev,
                      bloquearResgate: e.target.checked
                    }));
                  }}
                  disabled={enviando}
                  style={{ marginRight: '12px', transform: 'scale(1.2)' }}
                />
                <div>
                  <div style={{ fontWeight: '500', color: '#333', marginBottom: '4px' }}>
                    Bloquear Resgate
                  </div>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Impede que os usuários realizem resgates de prêmios
                  </div>
                </div>
              </label>
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center', 
                cursor: 'pointer',
                padding: '15px',
                borderRadius: '6px',
                border: '1px solid #e0e0e0',
                backgroundColor: configuracao.bloquearPontuacao ? '#f8f9fa' : '#fff',
                transition: 'all 0.2s ease'
              }}>
                <input
                  type="checkbox"
                  checked={configuracao.bloquearPontuacao}
                  onChange={(e) => {
                    e.persist();
                    setConfiguracao(prev => ({
                      ...prev,
                      bloquearPontuacao: e.target.checked
                    }));
                  }}
                  disabled={enviando}
                  style={{ marginRight: '12px', transform: 'scale(1.2)' }}
                />
                <div>
                  <div style={{ fontWeight: '500', color: '#333', marginBottom: '4px' }}>
                    Bloquear Pontuação
                  </div>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Impede que os usuários acumulem pontos
                  </div>
                </div>
              </label>
            </div>

            <div style={{ marginBottom: '30px' }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center', 
                cursor: 'pointer',
                padding: '15px',
                borderRadius: '6px',
                border: '1px solid #e0e0e0',
                backgroundColor: configuracao.bloquearSite ? '#f8f9fa' : '#fff',
                transition: 'all 0.2s ease'
              }}>
                <input
                  type="checkbox"
                  checked={configuracao.bloquearSite}
                  onChange={(e) => {
                    e.persist();
                    setConfiguracao(prev => ({
                      ...prev,
                      bloquearSite: e.target.checked
                    }));
                  }}
                  disabled={enviando}
                  style={{ marginRight: '12px', transform: 'scale(1.2)' }}
                />
                <div>
                  <div style={{ fontWeight: '500', color: '#333', marginBottom: '4px' }}>
                    Bloquear Site
                  </div>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Impede o acesso geral ao site
                  </div>
                </div>
              </label>
            </div>

            <div className="configuracoes-sistema-acoes">
              {enviando ? (
                <button 
                  type="button" 
                  disabled 
                  className="btn-primario configuracoes-sistema-salvar"
                >
                  SALVANDO...
                </button>
              ) : (
                <button 
                  type="submit" 
                  className="btn-primario configuracoes-sistema-salvar"
                >
                  SALVAR CONFIGURAÇÕES
                </button>
              )}
            </div>
          </form>
      </div>
    </div>
  );
}

export default function Configuracoes() {
  const history = useHistory();
  const location = useLocation();
  const aba = new URLSearchParams(location.search).get('aba') === 'regulamento'
    ? 'regulamento'
    : 'sistema';

  const selecionarAba = (proximaAba) => {
    history.push(proximaAba === 'regulamento'
      ? `${location.pathname}?aba=regulamento`
      : location.pathname);
  };

  return (
    <Container fluid className="configuracoes-painel">
      <h4 className="pt-3 pb-3 f-black">Configurações</h4>
      <hr className="hr-loja mt-0 mb-4" />
      <div className="nav nav-tabs mb-4 configuracoes-painel-abas" role="tablist" aria-label="Seções de configurações">
        <button
          type="button"
          role="tab"
          className={`nav-link ${aba === 'sistema' ? 'active' : ''}`}
          aria-selected={aba === 'sistema'}
          onClick={() => selecionarAba('sistema')}
        >
          Sistema
        </button>
        <button
          type="button"
          role="tab"
          className={`nav-link ${aba === 'regulamento' ? 'active' : ''}`}
          aria-selected={aba === 'regulamento'}
          onClick={() => selecionarAba('regulamento')}
        >
          Regulamento
        </button>
      </div>
      {aba === 'regulamento' ? <RegulamentoPainel /> : <ConfiguracoesSistema />}
    </Container>
  );
}
